/* ==========================================================================
   Smoosh Homepage — slider arrow navigation for Sections A + B overflow mode.

   Only active when a section has been rendered with .is-overflow on its grid
   (block count exceeded the desktop baseline). Mobile uses native scroll-snap;
   arrows are CSS-hidden there. Document-level event delegation so this
   survives any future re-renders.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__smooshHomepageLoaded) return;
  window.__smooshHomepageLoaded = true;

  function findGrid(navBtn) {
    var section = navBtn.closest('[data-smoosh-hp-overflow]');
    if (!section) return null;
    return section.querySelector('.is-overflow');
  }

  function cardStep(grid) {
    var card = grid.querySelector(':scope > a, :scope > .smoosh-hp-rcard, :scope > .smoosh-hp-hcard');
    if (!card) return 0;
    return card.getBoundingClientRect().width + 18;
  }

  function updateArrows(section) {
    var grid = section.querySelector('.is-overflow');
    if (!grid) return;
    var prev = section.querySelector('[data-smoosh-hp-nav="prev"]');
    var next = section.querySelector('[data-smoosh-hp-nav="next"]');
    if (!prev || !next) return;
    var atStart = grid.scrollLeft <= 1;
    var atEnd = grid.scrollLeft + grid.clientWidth >= grid.scrollWidth - 1;
    prev.toggleAttribute('disabled', atStart);
    next.toggleAttribute('disabled', atEnd);
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-smoosh-hp-nav]');
    if (!btn) return;
    e.preventDefault();
    var grid = findGrid(btn);
    if (!grid) return;
    var dir = btn.getAttribute('data-smoosh-hp-nav');
    var step = cardStep(grid);
    if (!step) return;
    grid.scrollBy({ left: dir === 'prev' ? -step : step, behavior: 'smooth' });
  });

  /* Bind scroll listeners on each overflow grid so arrow disabled states
     reflect scroll position. Idempotent — safe if called multiple times. */
  function bind() {
    var sections = document.querySelectorAll('[data-smoosh-hp-overflow]');
    sections.forEach(function (section) {
      if (section.__smooshHpBound) return;
      section.__smooshHpBound = true;
      var grid = section.querySelector('.is-overflow');
      if (!grid) return;
      grid.addEventListener('scroll', function () { updateArrows(section); }, { passive: true });
      window.addEventListener('resize', function () { updateArrows(section); });
      updateArrows(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind);
  } else {
    bind();
  }
})();
